/* force-featured-slider-fixed.js */
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('#shopify-section-template--18095964848314__featured_collection1');
  if (!section) return;

  // Lock card and image sizes
  section.querySelectorAll('.card-wrapper').forEach(card => {
    card.style.width = '180px';
    card.style.flex = '0 0 auto';
  });
  section.querySelectorAll('.card__media, .card__media img').forEach(el => {
    el.style.width = '144px';
    el.style.height = '144px';
    el.style.objectFit = 'contain';
    if (el.tagName === 'IMG') {
      el.removeAttribute('srcset');
      el.removeAttribute('sizes');
    }
  });

  const slider = section.querySelector('.slider');
  if (!slider) return;

  const initSlider = () => {
    let flkty = slider.flickity;
    if (!flkty) return;

    flkty.options.groupCells = false;
    flkty.options.cellAlign = 'left';
    flkty.options.contain = false;
    flkty.options.freeScroll = false;
    flkty.options.prevNextButtons = true;
    flkty.options.pageDots = false;

    // Force cell sizing recalculation
    flkty.reloadCells();
    flkty.resize();
  };

  initSlider();

  // Reinit on window resize
  window.addEventListener('resize', () => {
    initSlider();
  });
});
